<fieldset [attr.aria-label]="label">
  <div [class]="gridClass">
    <div *ngIf="name === 'myJudgement' || name === 'dealStages' || name === 'dealValues'">
      <div class="relative">
        <div class="absolute left-0 right-0 top-1/2 transform -translate-y-1/2 h-[2px] bg-gradient-to-r from-blue-royal via-indigo-500 to-violet-500 rounded-full z-0"></div>
        <div class="flex items-center justify-center space-x-6 relative z-10">
          <label *ngFor="let option of options; let i = index"
                 class="inline-block rounded-full text-xs font-medium py-1 px-3 tracking-wide w-20 text-center z-10"
                 [class.cursor-pointer]="!option.disabled"
                 [class.cursor-not-allowed]="option.disabled"
                 [class.opacity-25]="option.disabled"
                 [ngClass]="selectionStyles[option.value]">
            <input [type]="inputType"
                   [name]="name"
                   [value]="option.value"
                   [disabled]="option.disabled"
                   class="absolute w-0 h-0 opacity-0 sr-only"
                   [checked]="selectionStates[option.value]"
                   (change)="onSelectionChange(option.value)">
            <span>{{ option.label }}</span>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="name !== 'myJudgement' && name !== 'dealStages' && name !== 'dealValues'">
      <label *ngFor="let option of options"
             class="inline-block rounded-full text-xs font-medium py-1 px-3 mr-2 mb-2 tracking-wide"
             [class.cursor-pointer]="!option.disabled"
             [class.cursor-not-allowed]="option.disabled"
             [class.opacity-25]="option.disabled"
             [ngClass]="selectionStyles[option.value]">
        <input [type]="inputType"
               [name]="name"
               [value]="option.value"
               [disabled]="option.disabled"
               class="absolute w-0 h-0 opacity-0 sr-only"
               [checked]="selectionStates[option.value]"
               (change)="onSelectionChange(option.value)">
        <span>{{ option.label }}</span>
      </label>
    </div>
  </div>
</fieldset>
